export default "__VITE_ASSET__CpwQwhje__"